import { Component, OnInit } from '@angular/core';
import { ApplicationLanguages } from 'src/app/enums/lang';
import { ChangeLangService } from 'src/app/services/change-lang/change-lang.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
})
export class AboutUsComponent implements OnInit {
  deviceInfo: any;
  macOS = 'mac';
  iosOS = 'ios';
  currentLang = localStorage.getItem('lang') || ApplicationLanguages.Ar;
  ApplicationLanguages = ApplicationLanguages;

  constructor(private changeLangService: ChangeLangService) {}

  ngOnInit(): void {
    this.changeLangService.currentLanguage.subscribe((lang) => {
      this.currentLang = lang;
    });
  }
}
